module.exports = __webpack_public_path__ + "images/category_lp/fishing_gear/assessment_achievements/3_ca34ab8c8110e18b2cef89863a9aeea8.png";